import React from "react";

const clicklog_endpoint = `https://${process.env.REACT_APP_DOMAIN}/api/clicklog`;
/**
 * This component is a div.  It appears in the modal and shows all
 * the international links, positioned below the picture and above
 * the close button.
 *
 */
const ImageLinksDiv = ({ post, imageLinksData }) => {
  return (
    <div className="image-links-grid">
      {imageLinksData.data.map((imageLink, index) => (
        <a
          key={index}
          href={imageLink.linkUrl}
          onClick={() => beacon(imageLink.id)}
        >
          <img src={imageLink.imageUrl} alt={imageLink.imageUrl} />
        </a>
      ))}
    </div>
  );
};

const beacon = (mediaId) => {
  console.log("BEACON");
  navigator.sendBeacon(
    clicklog_endpoint,
    JSON.stringify({ mediaId: mediaId, username: "placeholder" })
  );
};

export default ImageLinksDiv;
